import { render, staticRenderFns } from "./comservices.vue?vue&type=template&id=06b9a398"
import script from "./comservices.vue?vue&type=script&lang=js"
export * from "./comservices.vue?vue&type=script&lang=js"
import style0 from "./comservices.vue?vue&type=style&index=0&id=06b9a398&prod&lang=scss"
import style1 from "./comservices.vue?vue&type=style&index=1&id=06b9a398&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports